/**
 * deviceQueryStorage — persistência do painel de filtros/ordenação da aba
 * "Dispositivos" (DEVICES-FILTER-SORT-1).
 *
 * Separado de deviceQuery.js de propósito: aquele módulo é puro e roda em
 * node nos testes; este toca localStorage. Mesmo padrão tolerante do
 * GisPanel (components/fleet/GisPanel.jsx): load faz MERGE sobre o DEFAULT
 * (um eixo novo em versão futura não invalida o que está salvo) e save é
 * silencioso (quota cheio / modo privado não pode derrubar a tela).
 *
 * NÃO persiste "Mostrar arquivados" nem "Mostrar pendentes e bloqueados":
 * são visões privilegiadas que disparam refetch — reabrir a tela já nelas
 * seria surpresa cara.
 */
import { DEVICE_QUERY_DEFAULTS } from "./deviceQuery.js";

export const DEVICE_VIEW_STORAGE_KEY = "ipwd-devices-view";

function storage() {
  try {
    return typeof localStorage !== "undefined" ? localStorage : null;
  } catch {
    return null; // acesso bloqueado (modo privado / política do navegador)
  }
}

/** @returns {object} estado SEMPRE válido, nunca lança. */
export function loadDeviceView() {
  try {
    const store = storage();
    const raw = store && store.getItem(DEVICE_VIEW_STORAGE_KEY);
    if (!raw) return { ...DEVICE_QUERY_DEFAULTS };
    const parsed = JSON.parse(raw);
    if (!parsed || typeof parsed !== "object" || Array.isArray(parsed)) {
      return { ...DEVICE_QUERY_DEFAULTS };
    }
    const merged = { ...DEVICE_QUERY_DEFAULTS };
    for (const key of Object.keys(DEVICE_QUERY_DEFAULTS)) {
      const fallback = DEVICE_QUERY_DEFAULTS[key];
      const value = parsed[key];
      if (value === undefined) continue;
      // tipo divergente (formato antigo/corrompido) → mantém o default
      if (Array.isArray(fallback)) {
        if (Array.isArray(value)) merged[key] = value.filter((v) => typeof v === "string");
        continue;
      }
      if (typeof value === typeof fallback) merged[key] = value;
    }
    return merged;
  } catch {
    return { ...DEVICE_QUERY_DEFAULTS };
  }
}

export function saveDeviceView(view) {
  try {
    const store = storage();
    if (!store) return;
    store.setItem(DEVICE_VIEW_STORAGE_KEY, JSON.stringify(view || {}));
  } catch {
    // quota cheio / storage indisponível — preferência é conveniência, não estado crítico
  }
}

export function clearDeviceView() {
  try {
    const store = storage();
    if (store) store.removeItem(DEVICE_VIEW_STORAGE_KEY);
  } catch {
    // silencioso
  }
}
